import React from 'react';

import { Loader } from '@eika/loader';
import { LoaderProps } from '@eika/loader/lib/Loader';

import './LoaderWithText.scss';

interface LoaderWithTextProps extends LoaderProps {
    title: string;
}

const LoaderWithText = ({ title, ...props }: LoaderWithTextProps) => (
    <div className="loader__loader-with-text">
        <Loader {...props} />
        <p>{title}</p>
    </div>
);

export default LoaderWithText;
